/**
 * What the run drawer shows IN PLACE of a launch form or a run's step list
 * while that workflow's FULL catalog entry is being read, or after the read
 * failed (plugin catalog round, 2026-10-06). The pane's catalog list is compact
 * — no schema, no steps — and a form or a list built from it would be wrong:
 * an empty form, or a log that claims every step ran. So: say it is loading,
 * or say it failed and offer to read again. Never guess.
 */
import Spinner from "./Spinner";

export interface CatalogEntryNoticeProps {
  status: "loading" | "error";
  what: "form" | "steps";
  onRetry: () => void;
}

export function CatalogEntryNotice({ status, what, onRetry }: CatalogEntryNoticeProps) {
  if (status === "loading") {
    return (
      <div
        role="status"
        data-testid={`catalog-entry-loading-${what}`}
        className="flex items-center gap-1.5 py-3 text-sm text-primary-gray-light-600"
      >
        <Spinner size={14} />
        {what === "form" ? "Loading the form…" : "Loading this workflow's steps…"}
      </div>
    );
  }
  return (
    <div
      role="alert"
      data-testid={`catalog-entry-error-${what}`}
      className="flex flex-col items-start gap-1 rounded-md border border-primary-error-200 bg-primary-error-50 px-3 py-2"
    >
      <p className="text-xs font-semibold text-primary-error-700">
        {what === "form"
          ? "We couldn't load this workflow's form."
          : "We couldn't load this workflow's steps."}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="text-xs font-semibold text-primary-error-700 underline"
      >
        Try again
      </button>
    </div>
  );
}

export default CatalogEntryNotice;
